import * as React from 'react';
import { FC } from 'react';
import { styled, Stack, Typography, useTheme } from '@mui/material';
import Currency from './Currency';
import formatPond from 'utils/formatPond';
import { SxProps } from '@mui/material/styles';
import { useLang } from '../../../utils/context/LangContext';

const Container = styled(Stack)`
  flex-direction: row;
  align-items: center;
`;
const CurrencyIconBox = styled(Stack)`
  width: 24px;
  margin-right: 4px;
`;

interface BalanceFloatingProps {
  balance: number;
  colorMode: 'dark' | 'light';
  isBonus?: boolean;
  style?: React.CSSProperties;
  textStyle?: SxProps;
  withoutFraction?: boolean;
  isLoading?: boolean;
  color?: string;
}

const BalanceFloating: FC<BalanceFloatingProps> = ({
  balance,
  colorMode,
  isBonus,
  style,
  textStyle,
  withoutFraction,
  isLoading,
  color,
}) => {
  const { t } = useLang();
  const theme = useTheme();

  return (
    <Container style={style}>
      <CurrencyIconBox>
        <Currency colorMode={colorMode} isBonus={isBonus} />
      </CurrencyIconBox>
      <Typography
        variant={'button'}
        sx={textStyle}
        fontSize={18}
        fontWeight={700}
        color={color ?? theme.colors.tertiary.base}
      >
        {isLoading
          ? t('floatingBalance')
          : formatPond(balance, withoutFraction)}
      </Typography>
    </Container>
  );
};

export default BalanceFloating;
